export function Button({
    variant = 'primary',
    size = 'md',
    className = '',
    children,
    ...rest
}) {
    const base = 'inline-flex items-center justify-center gap-2 font-medium rounded-md transition disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-500/40 focus-visible:ring-offset-1 ring-offset-cream-50';
    const variants = {
        primary: 'bg-ink-900 text-cream-50 hover:bg-ink-700 active:bg-ink-900',
        accent: 'bg-accent-500 text-white hover:bg-accent-700',
        ghost: 'text-ink-700 hover:bg-cream-100',
        outline: 'border border-cream-300 bg-white text-ink-900 hover:bg-cream-100',
        danger: 'bg-danger-500 text-white hover:bg-danger-500/90',
        link: 'text-accent-700 hover:underline px-0 py-0',
    };
    const sizes = {
        sm: 'px-2.5 py-1 text-xs',
        md: 'px-4 py-2 text-sm',
        lg: 'px-5 py-2.5 text-base',
    };
    return (
        <button
            className={[base, variants[variant], variant !== 'link' && sizes[size], className].filter(Boolean).join(' ')}
            {...rest}
        >
            {children}
        </button>
    );
}
